import { render, staticRenderFns } from "./RaiseAccount.vue?vue&type=template&id=c2c5cdfe&scoped=true&"
import script from "./RaiseAccount.vue?vue&type=script&lang=js&"
export * from "./RaiseAccount.vue?vue&type=script&lang=js&"
import style0 from "./RaiseAccount.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RaiseAccount.vue?vue&type=style&index=1&id=c2c5cdfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c5cdfe",
  null
  
)

export default component.exports